import React, { useEffect, useState, useContext } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const LandingFooter = (props) => {
  const [config, setConfig] = useState({});
  const navigate = useNavigate();
  let img = window.app.img;
  useEffect(() => {
    if (window.site) {
      setConfig(window.site);

    }

  }, [window.site]);



  if (config.common && config.common.imagesCDN) {
    img = config.common.imagesCDN;
  }
  const handlemenuclick = (e, path, id) => {
    window.localStorage.setItem("menuCode", id);
    navigate(path);
  }
  return (
    <footer className="footer-section footer-wrapper">
      <div className="footer-top">
        {/* <div className="container-fluid px-4 footer-container"> */}
        <div className="d-flex justify-content-between">

          <div className="footer-brand">
            <div className="footer-logo d-flex align-items-center gap-2">
              <img src={`${img}orasi/client/resources/orasiv1/images/logo_white.png`} alt="Orasi Logo" className="logo-img" />
              {/* <span className="brand-text">Orasi Media</span> */}
            </div>
            <p>Buy, sell, adapt and greenlight in one ecosystem.</p>
          </div>


          <div className="footer-links-container">
            <div className="mb-3">
              <div className="footer-links">
                <h6>Navigation</h6>
                <ul className="navbar-nav">
                  <li>
                    <a onClick={() => { navigate("/"); window.scrollTo(0, 0); }} style={{ cursor: "pointer" }}>Home</a>
                  </li>
                  <li>
                    <a onClick={() => { navigate("/aboutus"); window.scrollTo(0, 0); }} style={{ cursor: "pointer" }}>About Us</a>
                  </li>
                  <li><a onClick={() => { navigate("/blog"); window.scrollTo(0, 0); }} style={{ cursor: "pointer" }}>Blog</a>
                  </li>
                  <li><a onClick={() => { navigate("/contactus"); window.scrollTo(0, 0); }} style={{ cursor: "pointer" }}>Contact Us</a>
                  </li>
                    <li><a onClick={() => { navigate("/faq"); window.scrollTo(0, 0); }} style={{ cursor: "pointer" }}>FAQ</a>
                  </li>
                </ul>

              </div>
            </div>

            <div className="mb-3">
              <div className="footer-links">
                <h6>Products</h6>
                <ul>
                  <li><a onClick={() => { navigate("/productioncircle"); window.scrollTo(0, 0); }} style={{ cursor: "pointer" }}>Production Circle</a></li>
                  <li><a onClick={() => { navigate("/marketplace"); window.scrollTo(0, 0); }} productionhub style={{ cursor: "pointer" }}>Marketplace</a></li>
                </ul>
              </div>
            </div>

            <div className="mb-3">
              <div className="footer-links">
                <h6>Services</h6>
                <ul>
                  <li><a style={{ cursor: "pointer" }} onClick={() => { navigate("/aidubbing"); window.scrollTo(0, 0); }}>Live Dubbing</a></li>
                  <li><a style={{ cursor: "pointer" }} onClick={() => { navigate("/ailicensing"); window.scrollTo(0, 0); }}>Monetize with AI</a></li>
                </ul>
              </div>
            </div>

            <div className="mb-3">
              <div className="footer-links">
                <h6>Socials</h6>
                <ul>
                  <li><a href="https://www.linkedin.com/company/orasimedia/" target="_blank" rel="noopener noreferrer">LinkedIn</a></li>

                </ul>
              </div>
            </div>
          </div>
          {/* </div> */}
        </div>


      </div>

      <div className="footer-bottom">
        <div className="container-fluid px-4">
          <div className="row align-items-center">
            <div className="col-md-6">
              <p>&copy;2025 Orasimedia</p>
            </div>
            <div className="col-md-6 text-end">
              <div className="footer-legal justify-content-end">
                {props.menus &&
                  props.menus.length > 0 &&
                  props.menus.map(function (item, i) {
                    let pathlink = "/" + item.route;
                    return item.type === "footermenu" ? (

                      <>
                        {item?.menu !== "Contact Us" &&
                          <a href="#" id={`footer-menu-item-${item.menuid}`} onClick={(e) => handlemenuclick(e, pathlink, item.menuid)}>{item?.menu}</a>
                        }
                      </>

                    ) : (
                      ""
                    );
                  })}

              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;
